import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Disconnected = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHost = location.state?.isHost;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600">
      <div className="container mx-auto p-4 relative">
        {isHost && (
          <button
            onClick={() => navigate('/')}
            className="absolute top-4 right-4 px-4 py-2 bg-white/20 hover:bg-white/30 text-white rounded-xl transition-all duration-300"
          >
            Home
          </button>
        )}
        <div className="flex flex-col items-center justify-center min-h-screen px-4">
          <h1 className="text-2xl sm:text-3xl font-bold mb-6 text-white text-center">
            Connection Lost
          </h1>
          <p className="text-sm sm:text-base text-white text-center mb-8">
            The connection with your opponent has been lost.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Disconnected; 